import React, { useState } from "react";
import { useAppSelector } from "../../redux/configureStore";
import breakPoints from "./BreakPoints";
import { getRightMenuIsOpen } from "./selectors";
import AttendeeList from "../attendeeList/AttendeeList";
import Chats from "../chat/GiftedChat";
import SegmentSelector from "../common/SegmentSelector";
import LightTheme from "../theme/LightTheme";

const labels = ["Venue Chat", "Attendees"];

const RightSideContainer = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const isOpen = useAppSelector(getRightMenuIsOpen);

  return (
    <div className={`stickySide ${isOpen ? "open" : "closed"}`}>
      <div className="chatContainer">
        <SegmentSelector
          labels={labels}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
        />
        <div className="rightContent">
          {activeIndex === 1 ? <AttendeeList /> : <Chats />}
        </div>
      </div>
      <style jsx>
        {`
          .chatContainer {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            max-height: 100%;
            width: 350px;
          }
          .rightContent {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            max-height: 100%;
            overflow: auto;
          }
          .stickySide {
            display: flex;
            flex-direction: column;
            height: 100%;
            right: 0;
            background: #fdfefe;
            box-shadow: ${LightTheme.contentBorderBoxShadow};
            transition: right 0.5s ease;
            z-index: 2;
          }
          .closed {
            top: inherit;
            right: -350px;
            transition: right 0.5s ease;
          }

          @media only screen and (max-width: ${breakPoints.medium}px) {
            .stickySide {
              position: fixed;
            }
          }
        `}
      </style>
    </div>
  );
};
export default RightSideContainer;
